import React from 'react';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import logoLight from "../../assets/images/camp-logo.png";
import { REST_API_KEY, REDIRECT_URI } from "../../common/social/kakao/api";
import { BACKEND_HOST } from '../../api';
import axios from 'axios';
import { Button } from '@/Components/ui';

const KakaoPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [kakaoToken, setKakaoToken] = React.useState(null);
    const [hasUser, setHasUser] = React.useState(false);
    const [responseAuthNum, setResponseAuthNum] = React.useState(null);
    const [cookies, setCookie, removeCookie] = useCookies(['access_token']);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            phoneNum: '',
            authNum: 0,
        },
        validationSchema: Yup.object({
            phoneNum: Yup.number().positive().integer().required("전화번호를 입력해주세요.('-' 제외)"),
            authNum: Yup.number().test('check-authnum', "올바른 인증번호를 입력해주세요.", (val, ctx) => {return (responseAuthNum===null||(responseAuthNum.toString()===val.toString()));}),
        }),
        onSubmit: (values) => {
            let body = { "phone_num": '0'+(values.phoneNum).toString() }
            if (responseAuthNum === null) {
                fetch(
                    `${BACKEND_HOST}/auth/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body)
                })
                .then((response) => response.json())
                .then((data) => {
                    setResponseAuthNum(data['auth_num']);
                })
                .catch((e) => {console.log(e);});
            }
            else {
                fetch(
                    `${BACKEND_HOST}/api/token/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({...body, "kakao_token":kakaoToken})
                })
                .then((response) => response.json())
                .then((data) => {
                    localStorage.setItem("refresh_token", data["refresh_token"]);
                    setCookie("access_token", data["access_token"],{path: "/"});
                    navigate(`/user-voucher-list`);
                })
                .catch((e) => {console.log(e); removeCookie("access_token");});
            }
        }
    });
    


    React.useEffect(() => {
        const KAKAO_CODE = location.search.split('=')[1];
        axios.post(`https://kauth.kakao.com/oauth/token`, 
            `grant_type=authorization_code&client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&code=${KAKAO_CODE}`,
            {
                headers: {"Content-Type": "application/x-www-form-urlencoded"}
            }
        )
        .then((response) => response.data)
        .then((data) => {
            setKakaoToken(data["access_token"]);
            axios.post(`${BACKEND_HOST}/api/token/`, {"kakao_token":data["access_token"]})
            .then((response) => response.data)
            .then((data) => {
                setHasUser(data["has_user"]);
                if (data["has_user"]) {
                    localStorage.setItem("refresh_token", data["token"]["refresh_token"]);
                    setCookie("access_token", data["token"]["access_token"],{path: "/"});
                    navigate(`/user-voucher-list`);
                }
            })
            .catch((e) => {console.log(e);});
        })
        .catch((e) => {console.log(e);})
    }, [location, navigate, setCookie]);

    return (
        <React.Fragment>
                <div className="auth-page-content">
                    <div className="container-fluid">
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full px-3">
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="" height="150" />
                                        </Link>
                                    </div>
                                    {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-wrap -mx-3 justify-content-center">
                            <div className="w-full md:w-8/12 lg:w-6/12 xl:w-5/12 px-3">
                                <div className="card">
                                    <div className="card-body p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">KAKAO LogIn</h5>
                                            <p className="text-muted">전화번호 인증을 해주세요.</p>
                                        </div>
                                        {/* {error && error ? (<Alert color="danger"> {error} </Alert>) : null} */}
                                        {
                                            (hasUser) ? 
                                            null : 
                                            <div className="p-2 mt-4">
                                                <form
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}
                                                    action="#">

                                                    <div className="mb-3">
                                                        <label htmlFor="phoneNum" className="form-label">휴대폰 번호</label>
                                                        <input
                                                            name="phoneNum"
                                                            className="form-control"
                                                            placeholder="전화번호를 입력해주세요.('-' 제외)"
                                                            type="number"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                        />
                                                        {validation.touched.phoneNum && validation.errors.phoneNum ? (
                                                            <div className="invalid-feedback d-block">{validation.errors.phoneNum}</div>
                                                        ) : null}
                                                    </div>

                                                    {
                                                        (responseAuthNum !== null) ? 
                                                        <React.Fragment>
                                                            <div className="mb-3">
                                                                {/* <div className="float-end">
                                                                    <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                                </div> */}
                                                                <label className="form-label" htmlFor="password-input">인증번호</label>
                                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                                    <input
                                                                        name="authNum"
                                                                        type="number"
                                                                        className="form-control pe-5"
                                                                        placeholder="인증번호를 입력해주세요."
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                    />
                                                                    {validation.touched.authNum && validation.errors.authNum ? (
                                                                        <div className="invalid-feedback d-block">{validation.errors.authNum}</div>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            <div className="mt-4">
                                                                <Button  type="submit" color="success" className="w-100">Sign In</Button>
                                                            </div>
                                                        </React.Fragment> : 
                                                        <div className="mt-4">
                                                            <Button  type="submit" color="success" className="w-100">인증번호 받기</Button>
                                                        </div>
                                                    }
                                                </form>
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
        </React.Fragment>
    );
};

export default KakaoPage;
